export default {
  //存储数据
  state: {
    isCollapse: false,
    currentMenu: null,
    tabsList: [
      {
        meta: { title: "项目管理" },
        name: "project",
        path: "/project",
        title: "项目管理",
        hasChild: true,
      },
    ],
  },
  //调用方法
  mutations: {
    collapseMenu(state) {
      state.isCollapse = !state.isCollapse;
    },
    //选择标签 选择面包屑
    selectMenu(state, val) {
      if (val.path === "/project") {
        state.currentMenu = null;
      } else {
        state.currentMenu = val;
        //如果等于-1说明tabsList不存在那么插入，否则什么都不做
        let result = state.tabsList.findIndex((item) => item.path === val.path);
        result === -1 ? state.tabsList.push(val) : "";
      }
      // val.name === 'home' ? (state.currentMenu = null) : (state.currentMenu = val)
    },
    //关闭标签
    closeTab(state, val) {
      let result = state.tabsList.findIndex((item) => item.path === val.path);
      state.tabsList.splice(result, 1);
    },
    //删除数据，用于退出按钮
    remove(state, val) {
      state.tabsList = val;
    },
  },
  actions: {},
};
